<template>
  <div class="select-link">
    <a class="choice" @click="handleSelectLink()">
      <span class="mr-5">绘制热区</span>
      <i class="el-icon-edit"></i>
    </a>
    <HotZoneModal ref="HotZoneModal" @handleSubmit="onUpdate" />
  </div>
</template>

<script>
// import PropTypes from 'ant-design-vue/es/_util/vue-types'
import HotZoneModal from "./HotZoneModal";

// 绘制热区组件
export default {
  name: "SelectHotZone",
  components: {
    HotZoneModal,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    // 热区数据
    value: [],
    // 背景图片
    image: "",
  },
  data() {
    return {
      // 已选择的链接
      maps: [],
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler(val) {
        this.onUpdate(val);
      },
    },
  },
  created() {},
  methods: {
    // 更新已选择的数据
    onUpdate(maps) {
      this.maps = maps;
      this.$emit("change", maps);
    },

    // 打开链接选择器
    handleSelectLink() {
      const { maps, image } = this;
      console.log("我在打印打开链接选择器", maps, image);
      this.$refs.HotZoneModal.handle(maps, image);
    },
  },
};
</script>

<style lang="less" scoped>
.select-link {
  flex: 1;
  min-width: 150px;
}
.choice,
.link-title {
  display: block;
  line-height: 32px;
  white-space: nowrap;
  font-size: 12px;
}
.choice {
  background: #fff;
  border-radius: 2px;
  padding: 4px 6px;
  border: 1px solid #dcdee2;
  line-height: 20px;

  i {
    margin-right: 5px;
  }
  &:hover {
    border: 1px solid #006aff;
  }
}
</style>
